import { jsx } from "react/jsx-runtime";
import { List as MUIList } from "@mui/material";
import { forwardRef } from "react";
const ListInner = ({ ...restProps }, ref) => {
  return /* @__PURE__ */ jsx(
    MUIList,
    {
      ...restProps,
      ref
    }
  );
};
const List = forwardRef(ListInner);
export {
  List
};
